<template>
    <Card>
      <AjaxForm v-if="plan" :route="'admin/plan/edit/'+plan._id">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput label="عنوان" name="title" v-model="plan.title" type="text" placeholder="عنوان را وارد کنید"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput type="select" name="type" select-label="title"
                         v-model="plan.type"
                         reduce_select="id"
                         :select-options="[{id : 'seller',title : 'عرضه کننده'},{id : 'buyer',title : 'خریدار'}]"
                         placeholder="نوع ارتباط را مشخص کنید" label="مرتبط به"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput select-label="title" v-model="is_enabled"
                         reduce_select="id" type="select" name="is_enabled"
                         :select-options="[{id : '1',title : 'فعال'},{id : '0',title : 'غیرفعال'}]"
                         placeholder="وضعیت را مشخص کنید" label="وضعیت"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput name="description" v-model="plan.description" type="textarea" placeholder="توضیحات..." label="توضیحات"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <div class="form-group row">
              <div class="custom-control custom-switch switch-success">
                <input autocomplete="off" :checked="plan.is_proposed" type="checkbox" name="is_proposed" value="1" class="custom-control-input" id="is_proposed">
                <label class="custom-control-label text-muted" for="is_proposed">اشتراک پیشنهادی می باشد</label>
              </div>
            </div>
            <div class="form-group row">
              <div class="custom-control custom-switch switch-success">
                <input autocomplete="off" :checked="plan.is_starter" type="checkbox" name="is_starter" value="1" class="custom-control-input" id="is_starter">
                <label class="custom-control-label text-muted" for="is_starter">دوره آزمایشی (یکبار قابل انتخاب)</label>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput name="color" v-model="plan.color" type="color" label="رنگ اشتراک"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput type="number" v-model="plan.sort" name="sort" label="اولویت" placeholder="اولویت را وارد کنید"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4 d-flex">
            <label class="mr-3">تصویر</label>
            <ImagePicker :file_id="((plan.pic_id&& plan.pic_id._id)?plan.pic_id._id:null)"
                         :file_url="(plan.pic_url?plan.pic_url:null)" name="pic_id"></ImagePicker>
          </div>
          <div class="col-12 col-sm-12 col-md-12 mt2">
            <button @click="addPriceItem()" class="btn btn-info btn-sm mb-2" type="button">افزودن قیمت&nbsp;<i class="far fa-plus"></i></button>
            <div class="table-responsive">
              <table class="table table-bordered table-striped">
                <thead>
                <tr>
                  <th>عنوان</th>
                  <th>تعداد روز</th>
                  <th>تعداد سکه</th>
                  <th>قیمت</th>
                  <th>قیمت ویژه</th>
                  <th>حذف</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in prices" :key="prices">
                  <td><input type="text" name="item_titles[]" placeholder="عنوان..."
                             class="form-control form-control-sm" v-model="item.title"></td>
                  <td>
                    <NumberInput ClassName="form-control-sm" placeholder="تعداد روز..." name="n_days[]"
                                 v-model="item.n_day"></NumberInput>
                  </td>
                  <td>
                    <NumberInput ClassName="form-control-sm" placeholder="تعداد سکه..." name="n_coins[]"
                                 v-model="item.n_coin"></NumberInput>
                  </td>
                  <td>
                    <NumberInput ClassName="form-control-sm" placeholder="قیمت..." name="prices[]"
                                 v-model="item.price"></NumberInput>
                  </td>
                  <td>
                    <NumberInput ClassName="form-control-sm" placeholder="قیمت ویژه..." name="sp_price[]"
                                 v-model="item.sp_price"></NumberInput>
                    <CustomInput type="date"  name="sp_date[]" :date-time="true" v-model="item.sp_date" placeholder="تاریخ انقضا" without-label="true"></CustomInput>
                  </td>
                  <td><i class="fas fa-trash-can text-danger delete-btn" @click="deletePrice(index)"></i></td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-10 col-sm-8 col-md-5 mx-auto">
            <button class="btn btn-info btn-block" type="submit">ویرایش اطلاعات اشتراک</button>
          </div>
        </div>
      </AjaxForm>
      <div class="alert alert-danger" v-if="error">
      {{error}}
      </div>
    </Card>
</template>

<script>
import Card from "@/components/forms/Card";
import CustomInput from "@/components/CustomInput";
import ImagePicker from "@/components/ImagePicker";
import NumberInput from "@/components/NumberInput";
import AjaxForm from "@/components/forms/AjaxForm";
import {AppApi} from "@/api/AppApi";
import {mapActions} from "vuex";
import Vue3PersianDatetimePicker  from 'vue3-persian-datetime-picker';

export default {
  name: "PlanAdd",
  components: {AjaxForm, NumberInput, ImagePicker, CustomInput, Card,DatePicker: Vue3PersianDatetimePicker},
  data()
  {
    return{
      prices : [],
      id : this.$route.params.id,
      plan:null,
      loading : false,
      error : false,
      is_enabled : false,
    }
  },
  mounted()
  {
    this.setPageTitle('ویرایش اشتراک');
    this.setShowHead(true);
    this.initPage();
  },
  methods:{
    ...mapActions('app',{
      setPageTitle:'setPageTitle',
      setPageLoading:'setPageLoading',
      setShowHead : 'setShowHead'
    }),
    addPriceItem(){
      this.prices.push({});
    },
    async initPage()
    {
      this.setPageLoading(true);
      this.plan = null;
      this.error = null;
      this.id = this.$route.params.id;
      const result = await AppApi.getPlanInfoForEdit(this.id);
      if (result.ok)
      {
        this.plan = result.plan;
        this.prices = this.plan.prices;
        this.is_enabled = (this.plan.is_enabled?{id : '1',title : 'فعال'}:{id : '0',title : 'غیرفعال'})
        this.plan.type = (this.plan.type === 'seller'?{id : 'seller',title : 'عرضه کننده'}:{id : 'buyer',title : 'خریدار'})
      }
      else
      {
        this.error = result.error;
      }
      this.setPageLoading(false);
    },
    deletePrice(index)
    {
      this.prices.splice(index,1);
    },
    changeDate(item,index)
    {
      this.prices[index].sp_date = new Date(this.prices[index].sp_date)
    }
  }
}
</script>

<style scoped>
.delete-btn
{
  cursor: pointer;
  padding: 5px;
  font-size: 18px;
}
</style>